<template>
  <v-dialog v-model="downloadFileDialogShow" persistent width="40%" height="40%">
    <v-card>
      <v-card-title style="font-size: 18px;" class="alibabaPuHuiTiFontFamily">
        <p style="color: black">文件下载/导出</p>
        <v-spacer></v-spacer>
        <p @click="closeDialog" style="float:right;font-size:14px;color:#A6A6A6;cursor:pointer;"
           class="iconfontFamily">&#xe60d;</p>
      </v-card-title>
      <v-card-text class="pa-0">
        <div style="width: 100%;height: 460px;background-color: white;padding: 5px 30px 30px 30px">
          <p style="font-size: 14px;">请选择下载的文件格式</p>
          <div style="display: flex;justify-content: center;margin-top: 25px;">
            <div
                @click="exportType = 'CG'"
                :style="{'box-shadow' : exportType === 'CG' ? '0 0 4px 2px rgba(42,130,228,1)' : '0 0 4px rgba(42,130,228,0.25)'}"
                class="type-card">
              <p style="font-size: 36px;line-height: 50px;color: transparent;background-image: linear-gradient(rgba(22,217,227,1) 0%, rgba(48,199,236,1) 47%, rgba(70,174,247,1) 100%);-webkit-background-clip: text;font-weight: 400;"
                 class="FredokaOne">CG</p>
              <p style="color: black;" class="mt-4">保存为.CG格式</p>
              <p class="mt-4" style="color: rgba(128,128,128)">
                .CG格式为吉林一号·共生地球默认数据存储规范，可实现标记、图片、视频等全部数据的规范化存储。</p>
            </div>
            <div
                @click="exportType = 'other'"
                :style="{'box-shadow' : exportType === 'other' ? '0 0 4px 2px rgba(42,130,228,1)' : '0 0 4px rgba(42,130,228,0.25)'}"
                class="type-card custom-select"
                style="margin-left: 35px">
              <div style="display: flex;height: 60px">
                <img src="@/assets/file_manage/kml.png" alt="">
                <img style="margin-left: 10px" src="@/assets/file_manage/shp.png" alt="">
                <img style="margin-left: 10px" src="@/assets/file_manage/csv.png" alt="">
              </div>
              <p style="color: black;font-weight: 700;margin-top: 15px">保存为.kml .shp .csv等格式</p>
              <p style="margin-top: 10px">
                将.CG格式转换为其他格式存储，依据目标格式的数据规范，转换为对应格式的过程会有对应的数据损失</p>
              <div style="margin-top: 10px">
                <v-select
                    v-model="otherType"
                    placeholder="请选择下载的类型"
                    dense
                    class=""
                    :menu-props="{ bottom: true, offsetY: true }"
                    :items="['KML', 'KMZ', 'SHP', 'CSV']"
                    outlined
                ></v-select>
              </div>
            </div>
          </div>
          <div style="display: flex;justify-content: center;">
            <v-radio-group v-model="exportType" row>
              <v-radio style="margin-left: 20px;" value="CG">
              </v-radio>
              <v-radio style="margin-left: 210px;" value="other">
              </v-radio>
            </v-radio-group>
          </div>
          <div style="display: flex;justify-content: center">
            <div
                @click="cancelDownload"
                class="btn"
                style="background-color: rgba(245,245,245,1);color: rgba(81,81,81,1)">
              取消
            </div>
            <div
                @click="confirmDownload"
                class="btn"
                :style="{'background-color' : (otherType !== '' && exportType === 'other') || (exportType === 'CG') ? 'rgba(42, 130, 228, 1)' : 'rgba(42, 130, 228, 0.5)'}"
                style="color: white;margin-left: 50px">
              确定
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['downloadFileDialogShow'],
  data() {
    return {
      exportType: 'CG',
      canExport: true,
      otherType: ''
    }
  },
  methods: {
    closeDialog() {
      this.$emit('closeDownloadDialog')
    },
    cancelDownload() {
      this.$emit('closeDownloadDialog')
    },
    confirmDownload() {
      let fileType = this.exportType === 'CG' ? 'CG' : this.otherType
      if (fileType === 'SHP') {
        fileType = 'Shp'
      }
      if (!fileType) {
        return
      }
      this.$emit('confirmDownload', fileType)
    }
  }
}
</script>

<style scoped>
.type-card {
  position: relative;
  width: 227px;
  height: 282px;
  border-radius: 10px;
  padding: 22px;
  background-color: white;
}

.btn {
  width: 100px;
  height: 35px;
  cursor: pointer;
  justify-content: center;
  display: flex;
  align-items: center;
}
</style>

<style>

.custom-select .v-input__slot::after {
  display: none;
}
</style>